var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.$store.state.versionStatus],
      attrs: { id: "version-checker" },
    },
    [
      _vm.$store.state.versionStatus === "loading"
        ? _c("p", [_vm._v("Checking for updates…")])
        : _vm._e(),
      _vm.$store.state.versionStatus === "new-version"
        ? _c(
            "p",
            [
              _vm._v("\n\t\tThe Lounge "),
              _c("b", [
                _vm._v(_vm._s(_vm.$store.state.versionData.latest.version)),
              ]),
              _vm.$store.state.versionData.latest.prerelease
                ? [_vm._v(" (pre-release) ")]
                : _vm._e(),
              _vm._v("\n\t\tis now available.\n\t\t"),
              _c("br"),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.$store.state.versionData.latest.url,
                    target: "_blank",
                    rel: "noopener",
                  },
                },
                [_vm._v("\n\t\t\tRead more on GitHub\n\t\t")]
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.$store.state.versionStatus === "new-packages"
        ? _c("p", [
            _vm._v(
              "\n\t\tThe Lounge is up to date, but there are out of date packages Run\n\t\t"
            ),
            _c("code", [_vm._v("thelounge upgrade")]),
            _vm._v(" on the server to upgrade packages.\n\t"),
          ])
        : _vm._e(),
      _vm.$store.state.versionStatus === "up-to-date"
        ? [
            _c("p", [_vm._v("The Lounge is up to date!")]),
            _vm.$store.state.versionDataExpired
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-small",
                    attrs: { id: "check-now" },
                    on: { click: _vm.checkNow },
                  },
                  [_vm._v("\n\t\t\tCheck now\n\t\t")]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.$store.state.versionStatus === "error"
        ? [
            _c("p", [
              _vm._v(
                "Information about latest release could not be retrieved."
              ),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-small",
                attrs: { id: "check-now" },
                on: { click: _vm.checkNow },
              },
              [_vm._v("Try again")]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }